<!-- Young  :dataIndex="i.dataIndex"-->
<template>
  <div class="public-table">
    <a-table
      :pagination="false"
      :rowSelection="{
        selectedRowKeys: tableInfo.selectRows,
        onChange: onSelectChange,
      }"
      @change="tableSorterChange"
      :dataSource="tableData"
      :rowKey="rowKey"
      :loading="tableLoading"
    >
      <a-table-column
        v-for="(i, index) in columns"
        :key="index"
        :title="i.title"
        :dataIndex="i.dataIndex"
        :sorter="i.sorter"
        :width="i.width"
      >
        <template slot-scope="text, record">
          <!-- colhover效果↓↓↓ -->
          <a-tooltip
            v-if="i.type === 'tooltip'"
            placement="topLeft"
            :title="text"
          >
            <div
              class="tip-style"
              :style="{
                maxWidth: i.width - 32 + 'px',
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }"
            >
              {{ text }}
            </div>
          </a-tooltip>
          <!-- Col点击事件 -->
          <div
            v-else-if="i.type === 'cellClick'"
            @click="i.fun(record)"
            style="cursor: pointer"
          >
            <slot v-if="i.custom" :name="i.dataIndex" :row="record"></slot>
            <span v-else>{{ text }}</span>
          </div>
          <!-- 格式化Col文字 -->
          <slot v-else-if="i.custom" :name="i.dataIndex" :row="record"></slot>
          <!-- Col列YY/MM/DD HH:mm:ss -->
          <div v-else-if="i.type === 'YY-MM-DD hh:mm:ss'">
            {{ text | formatTimeA }}
          </div>
          <!-- Col列YY/MM/DD HH:mm -->
          <div v-else-if="i.type === 'YY-MM-DD hh:mm'">
            {{ text | formatTimeB }}
          </div>
          <!-- Col列YY/MM/DD -->
          <div v-else-if="i.type === 'YY-MM-DD'">{{ text | formatTimeC }}</div>
          <!-- 文本超长处理-配合width属性使用 -->
          <div v-else-if="i.type === 'elipsistext'">
            <span
              :style="{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                width: i.width + 'px',
              }"
            >
              {{ text }}
            </span>
          </div>
          <!-- 普通col列↓↓↓ -->
          <div v-else>{{ text }}</div>
          <!-- <div v-else class="elipsisText">{{ text }}</div> -->
        </template>
      </a-table-column>
      <a-table-column v-if="operateA" title="操作" :width="operateWidth">
        <template slot-scope="record">
          <div class="operate-wrap">
            <div
              v-for="(i, index) in operateA"
              :key="index"
              class="operate-item"
              :class="{ isLast: index !== operateA.length - 1 }"
              @click="i.fun(record)"
            >
              {{ i.name }}
            </div>
          </div>
        </template>
      </a-table-column>
    </a-table>
    <div class="pagination-wrap">
      <a-pagination
        class="pagination"
        showSizeChanger
        :total="tableInfo.total"
        :showTotal="(total) => `共 ${tableInfo.total} 条记录`"
        :current="tableInfo.pageIndex"
        :pageSize="tableInfo.pageSize"
        @change="tableInfo.changePageIndex"
        @showSizeChange="tableInfo.changePageSize"
        :pageSizeOptions="tableInfo.pageSizeOptions"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
  </div>
</template>

<script>
import { PublicFormatTime } from "@/utils/publicFunction";

export default {
  name: "PublicTable",
  props: {
    columns: { required: true },
    tableData: { required: true },
    tableInfo: { required: true },
    operateA: { required: false },
    tableLoading: { required: true },
    rowKey: { required: false, type: String, default: "id" },
    operateWidth: { required: false, type: Number },
  },
  data() {
    return {};
  },
  mounted() {},
  filters: {
    formatTimeA: (value) => {
      return PublicFormatTime(new Date(value), "YY-MM-DD hh:mm:ss");
    },
    formatTimeB: (value) => {
      return PublicFormatTime(new Date(value), "YY-MM-DD hh:mm");
    },
    formatTimeC: (value) => {
      return PublicFormatTime(new Date(value), "YY-MM-DD");
    },
  },
  methods: {
    // 表头选择框
    onSelectChange(selectedRowKeys,selectedRows) {
      let headerSelectAll = false;
      if (selectedRowKeys.length === this.tableData.length) {
        headerSelectAll = true;
      }
      this.$emit("selectTableRowFun", selectedRowKeys, headerSelectAll,selectedRows);
    },

    // table排序
    tableSorterChange(page, filter, sorter) {
      this.$emit("sortChangeFun", sorter);
    },
  },
};
</script>
<style lang='less'>
.public-table {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 10px;

  .elipsisText {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 150px;
  }

  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th {
    padding: 10px 10px !important;
  }
  .ant-table-column-sorters {
    display: flex !important;
    align-items: center !important;
    .ant-table-column-sorter {
      display: inline-block !important;
      margin-bottom: 3px !important;
      margin-left: 5px !important;
      margin-top: 0 !important;
      position: relative !important;
      top: 0 !important;
      right: 0 !important;
    }
  }
  .ant-table-thead > tr > th {
    color: #333;
    background: #f8f8fa !important;
    border: 0;
    div {
      font-weight: 500;
    }
  }
  .ant-table-tbody > tr > td {
    box-sizing: border-box;
    padding: 10px 16px;
    height: 40px;
    line-height: 40px;
    border: 0;
    color: #333;
    .table-img-box {
      height: 40px;
    }
  }
  .ant-table-tbody {
    tr {
      &:nth-child(2n) {
        td {
          background-color: #fcfdff;
        }
      }
    }
  }
}
</style>
<style lang='less' scoped>
// @import url(); 引入公共css类
.public-table {
  background: #ffffff;
  // 列加省略号和hover
  .tip-style {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // background: rgb(93, 116, 185);
  }
  .pagination-wrap {
    padding: 24px;
    display: flex;
    .pagination {
      margin-left: auto;
    }
  }
  .operate-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .operate-item {
      cursor: pointer;
      color: #5862cb;
    }
    .isLast {
      // margin-right: 32px;
      margin-right: 15px;
    }
  }
}
</style>
